import { UniversalMenuItem } from '@klv/molecules/universal-menu-item';
import { generateClassName } from '@klv/shared/utils/functions';
import * as gridStyles from '@klv/utils/grid/styles/grid.module.css';
import { useState } from 'react';
import { useScrollDirection } from '@klv/hooks/useScrollDirection';

import * as styles from './styles/subNav.module.css';

import type { ISubNav, ISubNavItem } from './types';

export const SubNav = ({
  className = '',
  menuItems = [],
  path = '',
  ...props
}: ISubNav) => {
  const [hasOpenDropdown, setHasOpenDropdown] = useState(false);
  const scrollDirection = useScrollDirection();
  return (
    <div
      className={generateClassName([
        className,
        styles.subNav,
        scrollDirection === 'down' && styles.scrolled,
        hasOpenDropdown && styles.hasOpenDropdown,
      ])}
      {...props}
    >
      <div className={generateClassName([gridStyles.grid, styles.container])}>
        <nav className={styles.nav}>
          <ul className={styles.list}>
            {menuItems.map(({ childItems, id, label, url: href }: ISubNavItem) => (
              <li
                className={generateClassName([
                  styles.listItem,
                  childItems?.length && styles.hasChildren,
                ])}
                key={id}
                onMouseEnter={() => childItems?.length && setHasOpenDropdown(true)}
                onMouseLeave={() => childItems?.length && setHasOpenDropdown(false)}
              >
                <UniversalMenuItem
                  aria-current={
                    (childItems?.some(({ url }) => url === path) && 'true')
                    || href === path
                    || undefined
                  }
                  className={generateClassName([
                    styles.link,
                    childItems?.length && styles.hasChildren,
                  ])}
                  href={href}
                >
                  <span>{label}</span>
                </UniversalMenuItem>
                {childItems && childItems.length > 0 && (
                  <ul className={styles.childList}>
                    {childItems.map(({ id: childId, label: childLabel, url: childHref }: ISubNavItem) => (
                      <li key={childId} className={styles.childListItem}>
                        <UniversalMenuItem
                          aria-current={childHref === path ? 'true' : undefined}
                          className={styles.childLink}
                          href={childHref}
                        >
                          {childLabel}
                        </UniversalMenuItem>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}; 
